export const USER_PERMISSIONS_TEST_IDS = {
  analystRoleButton: 'user-management-role-analyst',
  emailHeader: 'user-management-email-header',
  emailInput: 'user-management-invite-email-input',
  firstNameInput: 'user-management-invite-first-name-input',
  inviteFormSubmitButton: 'user-management-invite-form-submit-button',
  inviteUserButton: 'user-management-invite-user-button',
  lastLoginHeader: 'user-management-last-login-header',
  lastNameInput: 'user-management-invite-last-name-input',
  manageCompanyUsersButton: 'user-management-manage-company-users-button',
  searchInput: 'user-management-search-input',
  userPermissionsHeading: 'user-management-user-permissions-heading',
} as const;
